import React, { ReactElement, useState, useEffect } from "react";
import Book from "./Book.ts";
import { AccommodationIcon } from "../accommodation/AccommodationIcon.tsx";
import { BOOK_DATE_FORMAT } from "./BookConstant.ts";
import format from "date-fns/format";

interface BookListProps {
    token: string;
    books: Array<Book>;
    updateHadler: (id: string) => void;
}

export const BookListUnSync: React.FC<BookListProps> = ({ books, token, updateHadler }) => {
    const [contents, setContents] = useState<Array<ReactElement> | null>(null);

    useEffect(() => {
        const content_array: Array<ReactElement> = books.map((book, index) => {
            return (
                <tr
                    key={index}
                    style={{ minHeight: "36px", fontSize: ".8em", borderBottom: "1px solid var(--color-border)" }}
                    onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "rgb(226, 248, 175)")}
                    onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "")}
                >
                    <td className="accommodation" style={{ padding: "4px 10px", borderLeft: "1px solid var(--color-border)" }}>
                        {book.accommodation_id ? <AccommodationIcon token={token} id={book.accommodation_id} /> : null}
                    </td>
                    <td style={{ padding: "4px 10px", borderLeft: "1px solid var(--color-border)" }}>{format(book.start_date, BOOK_DATE_FORMAT)}</td>
                    <td className="free" style={{ padding: "4px 10px", borderLeft: "1px solid var(--color-border)" }}>
                        {book.name}
                    </td>
                    <td className="wide-hidden" style={{ padding: "4px 10px", borderLeft: "1px solid var(--color-border)" }}>
                        {book.days}泊
                    </td>

                    <td style={{ padding: "4px 10px", borderLeft: "1px solid var(--color-border)" }}>{format(book.created_at, BOOK_DATE_FORMAT)}</td>
                    <td style={{ padding: "4px 10px", borderLeft: "1px solid var(--color-border)" }}>
                        {book.payment_limit_date ? format(book.payment_limit_date, BOOK_DATE_FORMAT) : "-"}
                    </td>

                    <td className="wide-hidden" style={{ padding: "4px 10px", borderLeft: "1px solid var(--color-border)" }}>
                        {book.is_deleted ? "削除済み" : ""}
                    </td>
                    <td
                        className="button link"
                        style={{ padding: "4px 10px", borderLeft: "1px solid var(--color-border)", cursor: "pointer" }}
                        onClick={() => updateHadler(book.id)}
                    >
                        同期完了
                    </td>
                </tr>
            );
        });
        setContents(content_array);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token, books.length]);

    return (
        <div className="scrollable-container">
            <table className="item-list" style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead>
                    <tr
                        style={{
                            backgroundColor: "var(--color-header)",
                            borderTop: "1px solid var(--color-border)",
                            borderBottom: "1px solid var(--color-border)",
                        }}
                    >
                        <th
                            className="accommodation"
                            style={{ padding: "10px", fontSize: ".7em", textAlign: "center", color: "#444", borderLeft: "1px solid var(--color-border)" }}
                        >
                            施設
                        </th>
                        <th style={{ padding: "10px", fontSize: ".7em", textAlign: "center", color: "#444", borderLeft: "1px solid var(--color-border)" }}>
                            宿泊日
                        </th>
                        <th
                            className="free"
                            style={{ padding: "10px", fontSize: ".7em", textAlign: "center", color: "#444", borderLeft: "1px solid var(--color-border)" }}
                        >
                            宿泊者
                        </th>
                        <th
                            className="wide-hidden"
                            style={{ padding: "10px", fontSize: ".7em", textAlign: "center", color: "#444", borderLeft: "1px solid var(--color-border)" }}
                        >
                            宿泊日数
                        </th>

                        <th style={{ padding: "10px", fontSize: ".7em", textAlign: "center", color: "#444", borderLeft: "1px solid var(--color-border)" }}>
                            予約発生日
                        </th>
                        <th style={{ padding: "10px", fontSize: ".7em", textAlign: "center", color: "#444", borderLeft: "1px solid var(--color-border)" }}>
                            振込期限
                        </th>

                        <th
                            className="wide-hidden"
                            style={{ padding: "10px", fontSize: ".7em", textAlign: "center", color: "#444", borderLeft: "1px solid var(--color-border)" }}
                        >
                            削除済み
                        </th>
                        <th
                            className="button"
                            style={{ padding: "10px", fontSize: ".7em", textAlign: "center", color: "#444", borderLeft: "1px solid var(--color-border)" }}
                        >
                            完了
                        </th>
                    </tr>
                </thead>
                <tbody>{contents}</tbody>
            </table>
        </div>
    );
};
